// DO NOT EDIT: autogenerated by brokkr
import { CreateIconOptions } from "./types";
export const falE: CreateIconOptions = {
  "displayName": "FALE",
  "viewBox": "0, 0, 320, 512",
  "d": "M48 32C21.5 32 0 53.5 0 80L0 256 0 432c0 26.5 21.5 48 48 48l256 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L48 448c-8.8 0-16-7.2-16-16l0-160 208 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L32 240 32 80c0-8.8 7.2-16 16-16l256 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L48 32z"
};
